// extracted by mini-css-extract-plugin
module.exports = {"description":"_9eda8","wrapper":"e5777","item":"_0d97c","icon":"_69c7f","link":"e1fc0"};